<template>
	<div class="page model-apartments fade-in">
		<div v-if="animationEnded && !aiSnapshotProcess" class="filter-list flex flex-column">
			<apartments-filter ref="apartmentsFilterElement" :filtered-products="filteredProducts" @filter="filterChanged" >
				<apartments-table
          :apartments="filteredProducts"
          :current-apt="apartmentsPageCurrent"
          :loading="loading"
          @apartment-clicked="openApartment"
				/>
			</apartments-filter>
		</div>
		<transition>
			<div v-if="apartmentsPageCurrent" class="apartment-details-pane">
				<apartment-modal
          :apartment="apartmentsPageCurrent"
          :show-buttons="true"
          :show-link="false"
          :navigate-on-button-click="true"
          :show-thumbnail="showThumbnail"
          :next-apartment="nextApartmentPage"
          :previous-apartment="previousApartmentPage"
          @close="apartmentsPageCurrent = null"
          @apartment-clicked="navigateToApartment"
          @previous-apartment-clicked="openApartment"
          @next-apartment-clicked="openApartment"
        ></apartment-modal>
			</div>
		</transition>
	</div>
</template>

<script>
import ApartmentsFilter from "@/components/ApartmentsFilter.vue"
import { mapGetters } from "vuex"
import ApartmentModal from "@/components/ApartmentModal.vue"
import ApartmentsTable from "@/components/ApartmentsTable.vue"
// import ThreeScene from "@/components/ThreeScene.vue"
// import Accordion from "@/components/FpAccordion.vue"
// import FpNewIcon from "@/components/buttons/FpNewIcon";


export default {
	name: "ModelApartmentsPage",
	components: {
		ApartmentsTable,
		ApartmentModal,
		// ThreeScene,
		// FpNewIcon,
		ApartmentsFilter,
		// Accordion,
		// FpNewIcon,
		// FpBeautifullButton
	},
	computed: {
		apartmentsPageCurrent: {
			get() {
				return this.$store.getters.apartmentsPageCurrent
			},
			set(apartmentsPageCurrent) {
				this.$store.commit('apartmentsPageCurrent', apartmentsPageCurrent)

			}
		},
		animationEnded: {
			get() {
				return this.$store.getters.animationEnded
			},
			set(animationEnded) {
				this.$store.commit('animationEnded', animationEnded)

			}
		},
    aiSnapshotProcess(){
      return this.$store.getters['aIAgent/aiSnapshotProcess'];
    },
		showThumbnail() {
			return this.apartmentThumbnailDisplay && this.apartmentThumbnailDisplay.indexOf("apartments_page") > -1
		},
    settingsApartmentsFilter() {
      if (this.$store.getters.settings && this.$store.getters.settings.apartments_filter) {
        return this.$store.getters.settings.apartments_filter
      }
      return this.defaultSettings
    },
		filteredProducts() {
      const products = Array.isArray(this.products) ? this.products : Object.entries(this.products).map(e => e[1]);
			return products.sort((p1, p2) => p1['fp-sort'] - p2['fp-sort']).filter((product) => {
				let passedFilters = true;
				if (this.filter) {
					if (this.filter.building) {
						if (product.type_building) {
							if (product.type_building.id) {
								passedFilters = `${this.filter.building}` === `${product.type_building.id}`
							}
							if (!passedFilters) {
								if (product.type_building.name) {
									passedFilters = `${this.filter.building}` === `${product.type_building.name}`
								} else {
									passedFilters = false;
								}
							}
						}
					}
					if (!passedFilters) {
						return false;
					}
					if (this.filter.type) {
            if(product.apartment_type && product.apartment_type.id){
              passedFilters = `${this.filter.type}` === `${product.apartment_type.id}`
              if(!passedFilters){
                if(product.apartment_type.title){
                  passedFilters = `${this.filter.type}` === `${product.apartment_type.title}`;
                }
                if(!passedFilters){
                  passedFilters = `${this.filter.type}` === `${product.apartment_type.name}`
                }
              }
            }else if (product.type) {
							passedFilters = `${this.filter.type}` === `${product.type}`
						} else {
							passedFilters = false;
						}
					}
					if (!passedFilters) {
						return false;
					}
					if (this.filter.rooms) {
						if (product.type_rooms) {
							passedFilters = this.filter.rooms[0] <= +product.type_rooms && this.filter.rooms[1] >= +product.type_rooms
						} else {
							passedFilters = false;
						}
					}
					if (!passedFilters) {
						return false;
					}
					if (this.filter.quarter) {
						if (product.type_quarter) {
							passedFilters = `${this.filter.quarter}` === `${product.type_quarter}`
						} else {
							passedFilters = false;
						}
					}
					if (!passedFilters) {
						return false;
					}
					if (this.filter.plot) {
						if (product.type_plot) {
							passedFilters = `${this.filter.plot}` === `${product.type_plot}`
						} else {
							passedFilters = false;
						}
					}
					if (!passedFilters) {
						return false;
					}
					if (this.filter.floor) {
						if (typeof (product.floor_number) !== 'undefined') {
              if(
                  Array.isArray(this.filter.floor) &&
                  this.filter.floor.length === 2 &&
                  !isNaN(Number(product.floor_number))
              ){
                if(!(product.floor_number >= this.filter.floor[0] && product.floor_number <= this.filter.floor[1])){
                  passedFilters = false;
                }
              } else if(typeof(this.filter.floor) === 'string'){
                if(product.floor_id !== this.filter.floor){
                  passedFilters = false;
                }
              }
            }
					}
          if (!passedFilters) {
            return false;
          }

          let customFieldsKeys = [];
          let customFieldsFiltersResults = {};
          if(this.settingsApartmentsFilter.custom_fields && Array.isArray(this.settingsApartmentsFilter.custom_fields)){
            customFieldsKeys = this.settingsApartmentsFilter.custom_fields.map(field => field.key);
            for(const customFieldKey of customFieldsKeys){
              const productCustomField = product.custom_fields && product.custom_fields.length > 0 ? product.custom_fields.find(field => field.key === customFieldKey) : [];
              if(productCustomField){
                if(this.filter[customFieldKey]){
                  customFieldsFiltersResults[customFieldKey] = `${this.filter[customFieldKey]}` === `${productCustomField.value}`;
                }
              }
            }
          }
          if(customFieldsFiltersResults && Object.keys(customFieldsFiltersResults).length > 0){
            if(!Object.values(customFieldsFiltersResults).every(result => result)){
              passedFilters = false;
            }
          }
          const staticFilterKeys = ['building', 'type', 'rooms', 'quarter', 'plot', 'floor'];
          const dynamicFilterKeys = Object.keys(this.filter).filter(key => !staticFilterKeys.includes(key) && key && this.filter[key] && !customFieldsKeys.includes(key));
          let dynamicFiltersResults = {};
          dynamicFilterKeys.forEach(key => {
            if (this.filter[key]) {
              if (product && product.display_fields && product.display_fields.length) {
                const dynamicField = product.display_fields.find(field => field['field'] === `product_dynamic_${key}`);
                if(dynamicField) {
                  dynamicFiltersResults[dynamicField.field] = `${this.filter[key]}` === `${dynamicField.value}`
                }
              }
            }
          });
          if(dynamicFilterKeys.length > 0 && !Object.values(dynamicFiltersResults).every(result => result)){
            passedFilters = false;
          }
				}
				return passedFilters;
			});
		},
		...mapGetters([
			'isSideMenu',
			'currentProjectId',
			'filterOptions',
			'apartmentPageEnabled',
			'apartmentThumbnailDisplay',
			'products',
			'isMobile',
			'showApartments3DModel',
			'modelUrl',
			'hdrUrl',
      'locale'
		])
	},
	data() {
		return {
			filter: null,
			loading: false,
			nextApartmentPage: null,
			previousApartmentPage: null,
			sidePanelOpen: true,

		}
	},
	methods: {
		async filterChanged(filter) {
			this.filter = filter
			this.broadcastAction({
				action: 'show-building',
				building: filter.building
			})
			//await this.searchProducts()
		},
		openApartmentByTitle(title) {
			const apartment = Object.entries(this.products).map(entry => entry[1]).find((product) => {
				return product.title === title
			})
			if (apartment) {
				this.openApartment(apartment, false)
			}
		},

		openApartment(apt, broadcast = true) {
      if(this.$refs.apartmentsFilterElement && this.isMobile){
        this.$refs.apartmentsFilterElement.closeCollapse();
      }
      if (broadcast) {
        this.broadcastAction({
          action: 'show-apartment',
          apartment: apt
        })
      }
      if (this.apartmentsPageCurrent) {
        if (apt.id === this.apartmentsPageCurrent.id) {
          this.closeApartment()
        } else {
          this.apartmentsPageCurrent = null
          setTimeout(() => {
            this.apartmentsPageCurrent = apt
          }, 300)
        }
      } else {
        this.apartmentsPageCurrent = apt
      }

      const keys = Object.keys(this.filteredProducts)
      const index = keys.indexOf(`${apt.id}`)
      if (index > -1) {
        const nextIndex = index + 1
        const previousIndex = index - 1
        if (keys[nextIndex]) {
          this.nextApartmentPage = this.filteredProducts[keys[nextIndex]]
        } else {
          this.nextApartmentPage = null
        }
        if (keys[previousIndex]) {
          this.previousApartmentPage = this.filteredProducts[keys[previousIndex]]
        } else {
          this.previousApartmentPage = null
        }
      }
			/*
			we always show the apartment model regardless if it is floored or not and mobile or not, requested by tomer and kobi 30/9/2025
			if (!this.isMobile || apt.type_building.floors_active) {
			} else {
				this.navigateToApartment(apt)
			}*/
		},
		closeApartment() {
			this.apartmentsPageCurrent = null
			this.nextApartmentPage = null
			this.previousApartmentPage = null
		},
		navigateToApartment(apt) {
			if (this.apartmentPageEnabled && apt.type_show_page) {
				this.$router.push({ name: 'apartment', params: { lang: this.locale, projectId: this.currentProjectId, apartmentId: apt.id } })
			}
		},
		listenFramebus() {
			this.$frameBus.on('message', this.onFramebusMessage)
		},
		unListenFramebus() {
			this.$frameBus.off('message', this.onFramebusMessage)
		},
		onFramebusMessage(data) {
			const { action } = data
			if (action) {
				switch (action) {
					case 'open-apartment':
						if (data["apartmentTitle"]) {
							this.openApartmentByTitle(data["apartmentTitle"])
						}
						break
					case 'close-apartment':
						this.closeApartment()
						break
					case 'goToApartmentPage':
						this.navigateToApartment(data.data)
						break
					case 'animationEnd':
						this.animationEnded = true
						break
				}
			}
		},
		broadcastAction(data) {
			if (this.$frameBus) {
				this.$frameBus.emit('message', data);
			}
		}
	},
	/*beforeRouteEnter(to, from, next){
	next(vm => {
		//vm.loadProject(to)
		vm.searchProducts()
	})
},*/
	/*beforeRouteUpdate(){
		this.searchProducts()
	},*/
	mounted() {
		this.listenFramebus();
		if (this.isMobile) this.sidePanelOpen = false
	},
	beforeUnmounted() {
		this.unListenFramebus()
	}
}
</script>

<style lang="scss">
.page.model-apartments {
	display: flex;
	flex-flow: row;
	justify-content: flex-start;
	.AccordionHeaderWrapper {
		width: 100%;
		z-index: 11;
	}
	.toggleIcon {
		position: absolute;
		top: -2.2rem;
		right: 5rem;
		z-index: 15;
	}
	.apartments-filter {
		flex-grow: 1;
		z-index: 11;
		opacity: 1;
		&.v-enter-active,
		&.v-leave-active {
			transition: opacity 2s ease;
		}

		&.v-enter-from,
		&.v-leave-to {
			
			opacity: 0
		}
	}
	.apartments-table {
		padding: 10px;
		z-index: 11;
		opacity: 1;

	}

	.fpBeautifullBtn svg {
		fill: black;
	}

	.apartments-list {
		margin-top: 1rem;
	}

	.apartment-details-pane {

		&.v-enter-active,
		&.v-leave-active {
			transition: transform .3s ease;
		}

		&.v-enter-from,
		&.v-leave-to {
			transform: translateX(-500px);
		}
	}

	
	.filter-list {
		max-height: 100svh;
		position: absolute;
		right: 0;
    max-width: 30vw;
    width: 500px;
		z-index: 12;
		.apartments-table {
			flex-grow: 1;
		}
	}


}

.is-desktop,
.is-tablet {
	.page.model-apartments {
	
		.apartment-details-pane {
			position: absolute;
			left: 0;
		}
	}
}

.is-mobile {
	.page.model-apartments {
		flex-flow: column;
		.filter-list {
	
			height: auto;
			right: 0;
      max-width: 100vw;
			width: 100vw;
			z-index: 26;
			.apartments-table {
				flex-grow: 1;
				padding-bottom: 10rem;
			}
		}
		.AccordionHeaderWrapper {
			width: 100%;
		}
		.apartments-table {
			max-height: 70svh;
		}
	}
}

.fp-side-menu-wrapper+.fp-app-wrapper .page.model-apartments {



	.apartments-nav-arrows {
		margin-left: 10px;
		margin-right: 10px;
	}



	.apartments-compere {
		position: absolute;
		left: auto;
		top: auto;
		right: 310px;
		bottom: auto;
		margin-left: auto;
		align-self: flex-start;
		transition: transform .5s ease;
		transform: rotate(0);
		transform-origin: 100% 100%;

		&.rotate {
			transform: rotate(-90deg) translateX(90px);
		}
	}
}

.ltr .fp-side-menu-wrapper+.fp-app-wrapper .page.model-apartments {
	.filter-list {
		right: auto;
		left: 0;
	}
}

.ltr .page.model-apartments {

	.apartment-modal {
		margin-right: 3rem;
		margin-left: 0;
	}

	.apartment-details-pane {
		right: 0;
		left: auto;
		&.v-enter-from,
		&.v-leave-to {
			transform: translateX(500px);
		}
	}
	.apartments-filter {

		&.v-enter-from,
		&.v-leave-to {
			transform: translateX(-500px);
		}
	}
	.apartments-table {

		&.v-enter-from,
		&.v-leave-to {
			transform: translateX(-500px);
		}
	}
}
</style>
